import { render, staticRenderFns } from "./CardTemperatureHum.vue?vue&type=template&id=60ba065f&"
import script from "./CardTemperatureHum.vue?vue&type=script&lang=js&"
export * from "./CardTemperatureHum.vue?vue&type=script&lang=js&"
import style0 from "./CardTemperatureHum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports